import React, { useEffect } from 'react';
import {
  Link,
} from "react-router-dom";

import { connect } from 'react-redux';
import { format } from 'date-fns';

import jonathanMifsudPhoto from '../../assets/images/team/jonathan-mifsud.jpg';
import jeremyMifsudPhoto from '../../assets/images/team/jeremy-mifsud.jpg';
import davidSeisunPhoto from '../../assets/images/team/david-seisun.jpg';

const EMAILLIST = 9

function WebinarCard({
  webinar,
    country,
  onDemand,
    compact,
    mode,
}) {

  const {
    category,
    title,
    slug,
    intro,
    date,
    duration,
    img,
  } = webinar

  const cardBackground = mode === 'dark' ? "bg-white" : "bg-white"
  const titleColor = mode === 'dark' ? "text-gray-100" : "text-gray-900"
  const textColor = mode === 'dark' ? "text-gray-300" : "text-gray-500"
  const containerClass = mode === 'dark' ? "flex flex-col rounded-2xl shadow-lg ring-1 ring-gray-900/5  overflow-hidden" : "flex flex-col rounded-lg shadow-lg overflow-hidden"
  const cardStyle = compact ? {
        // make background image semi transparent
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${img})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      } : {}


  return (

    <div className={containerClass}
      style={cardStyle}
    >
      {!compact &&
          <div className="flex-shrink-0">
            <img className="h-48 w-full object-cover" src={img || "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=1679&amp;q=80"} alt="" />
          </div>
      }
      <div className={`flex-1 p-6 flex flex-col justify-between`}>
        <div className="flex-1">
          <p className="text-sm leading-5 font-medium text-orange-600">
            <Link to={`/${country}/webinar/${slug}`} className="hover:underline">
              {category}
            </Link>
          </p>
          <Link to={`/${country}/webinar/${slug}`} className="block">
            <h3 className={`mt-2 text-xl leading-7 font-semibold ${titleColor}`}>
              {title}
            </h3>
            <p className={`mt-3 text-base leading-6 ${textColor} ${compact ? 'text-xs' : ''}`}>
              {intro}
            </p>
          </Link>
        </div>

        {compact &&
            <div className={`mt-6 flex items-center text-xs ${textColor}`}>
              <time datetime={date && format(new Date(date), "yyyy-MM-dd")}>
                {date && format(new Date(date), "do MMM yyyy")}
              </time>
              <span className="mx-1">
                &middot;
              </span>
              {duration} min
            </div>
        }
        {!compact &&
          <div className="mt-6 flex items-center">
            {/*<div className="flex-shrink-0">
              <Link to={`${country}/webinar/${slug}`}>
                <img className="h-10 w-10 rounded-full"
                  src={jonathanMifsudPhoto}
                  alt=""
                  style={{
                    objectPosition: "center",
                    objectFit: "cover"
                  }}
                />
              </Link>
            </div>*/}
            <div >
             {/* className="ml-3" <p className={`text-sm leading-5 font-medium ${titleColor}`}>

                <Link to={`${country}/webinar/${slug}`} className="hover:underline">
                  Jonathan Mifsud
                </Link>
              </p>*/}
              <div className={`flex text-sm leading-5 ${textColor}`}>
                {!onDemand &&
                  <>
                    <time datetime={date && format(new Date(date), "yyyy-MM-dd")}>
                      {date && format(new Date(date), "do MMM yyyy")}
                    </time>
                    <span className="mx-1">
                      &middot;
                    </span>
                  </>
                }
                <span>
                  {duration} min
                </span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  // const profile = state && state.my && state.my.profile  || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

  // const userInList = state.createAccount && state.createAccount.inList && state.createAccount.inList[EMAILLIST]

  return {
    // userInList,
    // profile
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // contactInList: (data) => dispatch(CREATEACCOUNTACTIONS.contactInList(data)),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WebinarCard) 
